module.exports = __webpack_public_path__ + "static/media/12c96ac2-74c4-49c7-a32a-096b37baeb63_1.33d0cf75ca2d988c5b133f8f602388ef.fb0dedd1.jpeg";